export default __webpack_public_path__ + "static/media/cube.654c486d.png";